import src from "IMAGE";
export default { src, width: 1372, height: 588, blurWidth: 0, blurHeight: 0};
